import defaultAttributes from '../defaultAttributes';

const Hexagon = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d:
          'M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z',
      },
    ],
  ],
];

export default Hexagon;
